"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _SiteSettings = _interopRequireDefault(require("./SiteSettings"));

var _constants = require("./constants");

var _normalizeSiteSettingsAPIResponse = _interopRequireDefault(require("./normalizeSiteSettingsAPIResponse"));

var _fromJS, _handleActions;

var initialState = (0, _immutable.fromJS)((_fromJS = {}, (0, _defineProperty2.default)(_fromJS, _constants.ALL_DOMAINS_KEY, null), (0, _defineProperty2.default)(_fromJS, "byDomain", (0, _immutable.Map)()), _fromJS));

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchSiteSettingsActionTypes.SUCCESS, function (state, action) {
  return (0, _normalizeSiteSettingsAPIResponse.default)(action.payload.data);
}), (0, _defineProperty2.default)(_handleActions, _actions.SaveSiteSettingsChangesActionTypes.SUCCESS, function (state, action) {
  var data = action.payload.data;

  if (data.bodyOverrideByDomain) {
    return (0, _normalizeSiteSettingsAPIResponse.default)(data);
  }

  return state.set('byDomain', Object.keys(data).reduce(function (acc, domain) {
    return acc.set(domain, new _SiteSettings.default(data[domain]));
  }, state.get('byDomain')));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;